import axios from "axios";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import { useQuery } from "react-query";

export default function useGetAllUsers() {
    
  const { config } = useContext(LoginContext);

  return useQuery(
    "users",
    async () => {
      let response = await axios.get(`${config.api}/api/User`);

      return response.data;
    },
    {
      staleTime: 1000 * 60 * 5,
    }
  );
}
